<template>
    <div class="datatable-dropdown" v-click-outside="() => showed = false">
        <Button :title="translate(title)" @click="show" :badge="modelValue.length ? String(modelValue.length) : null"/>
        <div class="datatable-dropdown-menu" v-if="showed">
            <div class="datatable-select-search">
                <input type="text" :placeholder="translate('labels.search')" @input="fetchOptions" v-model="search">
                <i class="icon-search4"></i>
            </div>
            <div class="datatable-select-options">
                <div class="datatable-select-group">
                    <div class="datatable-select-option selected" v-for="selectedOption in selectedOptions">
                        <div class="uniform-checker">
                            <span class="checked">
                                <input type="checkbox" class="checkBox" @click="selectOption(true, selectedOption)">
                            </span>
                        </div>
                        <span class="">{{ makeOptionName(selectedOption) }}</span>
                    </div>
                    <div class="datatable-select-option" v-for="searchOption in searchOptions">
                        <div class="uniform-checker">
                            <span class="">
                                <input type="checkbox" class="checkBox" @click="selectOption(false, searchOption)">
                            </span>
                        </div>
                        <span class="">{{ makeOptionName(searchOption) }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { httpClient } from '../../../../services/HttpClient';
import vClickOutside from 'click-outside-vue3'
import Button from "../../datatable/filters/ButtonComponent.vue";
export default {
    name: "Multiautocomplete",
    components: {
        Button
    },
    props: {
        modelValue: {
            type: Array,
            default: () => []
        },
        optionKey: {
            type: String,
            default: "uuid",
        },
        optionValue: {
            type: String,
            default: "name"
        },
        groupValue: {
            type: String,
            default: null
        },
        url: {
            type: String
        },
        title: {
            type: String
        }
    },
    data() {
        return {
            selectedOptions: [],
            searchOptions: [],
            showed: false,
            search: ''
        }
    },
    methods: {
        async show() {
            if (this.showed) {
                this.showed = !this.showed
                return
            }

            if (this.modelValue.length > 0) {
                await httpClient.get(this.url, {
                    uuids: this.modelValue,
                    limit: 0
                }).then((response) => {
                    this.selectedOptions = response.data.data
                })
            }

            await this.fetchOptions()

            this.showed = !this.showed
        },
        async fetchOptions() {
            await httpClient.get(this.url, {
                search: this.search,
                limit: 5,
                ignore_uuids: this.selectedOptions.map(item => item.uuid)
            }).then((response) => {
                this.searchOptions = response.data.data
            })
        },
        async selectOption(checked, option) {
            if (checked) {
                this.selectedOptions = this.selectedOptions.filter(item => item !== option)
                this.$emit('update:model-value', this.selectedOptions.map(item => item[this.optionKey]))
            } else {
                this.selectedOptions.push(option)
                this.searchOptions.splice(this.searchOptions.indexOf(option), 1)
                this.$emit('update:model-value', this.selectedOptions.map(item => item[this.optionKey]))
                await this.fetchOptions()
            }
        },
        makeOptionName(option) {
            if (this.groupValue) {
                let groupWay = this.groupValue.split(".")

                function deepGet(val, keys) {
                    if (!keys.length) return val

                    let key = keys[0]

                    return deepGet(val[key], keys.splice(1))
                }

                return `${deepGet(option, groupWay)} - ${option[this.optionValue]}`
            } else {
                return option[this.optionValue]
            }
        }
    },
    directives: {
        clickOutside: vClickOutside.directive
    }
}
</script>
<style scoped>
.datatable-dropdown {
    user-select: none;
    position: relative;
    display: inline-block;
}

.datatable-dropdown-menu {
    background: #ffffff;
    position: absolute;
    z-index: 10;
    margin-top: 10px;
    box-shadow: 0 4px 8px -2px #091e4240, 0 0 1px #091e424f;
    border-radius: 2px;
    min-width: 100%;
    white-space: nowrap;
}

.datatable-select-search {
    height: 40px;
    display: flex;
    border-bottom: solid 1px #dfe1e6;
    justify-content: space-between;
    padding: 0 10px;
}

.datatable-select-search input{
    margin: unset;
    padding: unset;
    border: unset;
    width: 200px;
}

.datatable-select-search input:focus {
    outline: none;
}

.datatable-select-search i{
    font-size: 12px;
    height: 20px;
    line-height: 20px;
    width: 20px;
    margin: 10px 0;
}

.datatable-select-options {
    padding: 5px 0;
    max-height: 250px;
    overflow-y: auto;
}

.datatable-select-option {
    display: flex;
    padding: 8px 10px;
    column-gap: 10px;
    transition: background 0.3s;
}

.datatable-select-option:hover {
    background: #eaeaea;
    cursor: pointer;
}

.datatable-select-option.selected {
    background: #f6f6f6;
}

.datatable-select-group .title{
    margin: 10px 10px 0 10px;
    font-weight: 500;
}
</style>